import React from "react";
import { useSite } from "../context/SiteContext";
import { telHref, whatsappHref } from "../utils/format";

/** WhatsApp + Call buttons fixed at the bottom-left of every page (the right side is used by live chat & scroll-top). */
const FloatingActions = () => {
  const { config } = useSite();
  const c = config.contact;
  return (
    <div className="floating-actions" aria-label="Quick contact">
      {c.whatsapp && (
        <a
          href={whatsappHref(c.whatsapp, config.whatsappMessage)}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-actions__btn floating-actions__btn--whatsapp"
          aria-label="Chat on WhatsApp"
          title="WhatsApp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      )}
      <a href={telHref(c.emergencyPhone)} className="floating-actions__btn floating-actions__btn--call" aria-label={`Call ${c.emergencyPhoneDisplay}`} title="Call us">
        <i className="fas fa-phone-alt"></i>
      </a>
    </div>
  );
};

export default FloatingActions;
